exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n  padding: 20px 20px 20px 10px; }\n\nform {\n  padding: 10px 20px; }\n\nform .label--block {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/components/message/message.component.scss
// module id = ../../../../../src/app/components/message/message.component.scss
// module chunks = main